import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlassCheers, faPen } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";

import { IconButton } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

import type { IPartner, IProfile } from "App/Modules/Models";
import { Permission } from "App/Modules/Models";
import { hasUserPermissionAnywhere } from "App/ReactComponents/Shared";

import { HolidaysList } from "./HolidaysList";

type HolidaysProps = {
    partner: IPartner;
    profile: IProfile;
    hasLimitedPermissions: boolean;
    isLoading: boolean;
    isEditHolidayScheduleDialogOpen: (value: boolean) => void;
};

export const Holidays = (props: HolidaysProps) => {
    const { partner, profile, hasLimitedPermissions, isEditHolidayScheduleDialogOpen } = props;
    const { t } = useTranslation();
    const utcNow = moment(new Date());

    const handleEditHolidaySchedule = () => {
        isEditHolidayScheduleDialogOpen(true);
    };

    return (
        <div className="card">
            <div className="scrollable-list">
                <div className="partner-details__header-with-edit">
                    <h2 className="title title--h3 scrollable-list__header">
                        <FontAwesomeIcon icon={faGlassCheers} className="scrollable-list__header-icon" />
                        {t("Entities.Schedule.HolidaySchedule")}
                    </h2>
                    {!props.isLoading && !hasLimitedPermissions ? (
                        <IconButton
                            className="icon-button"
                            onClick={handleEditHolidaySchedule}
                            disabled={!hasUserPermissionAnywhere(profile, Permission.PartnerSettings)}
                        >
                            <FontAwesomeIcon className="icon-button__icon" icon={faPen} />
                        </IconButton>
                    ) : null}
                </div>
                {props.isLoading ? (
                    <Skeleton height="4em" />
                ) : (
                    <div className="scrollable-list__content scrollable-list__content--dark">
                        {!hasLimitedPermissions &&
                        partner &&
                        partner.holidaySchedule !== null &&
                        partner.holidaySchedule.holidays.length > 0 ? (
                            <div className="scrollable-list__scroller">
                                <h3 className="title title--h3">{t("Entities.Schedule.HolidaysOngoing")}</h3>
                                <HolidaysList
                                    holidays={
                                        partner.holidaySchedule.holidays.filter(
                                            (u) => u.dtStart <= utcNow && u.dtStop > utcNow,
                                        ) || []
                                    }
                                    presence="ongoing"
                                />
                                <h3 className="title title--h3">{t("Entities.Schedule.HolidaysUpcoming")}</h3>
                                <HolidaysList
                                    holidays={partner.holidaySchedule.holidays.filter((u) => u.dtStart > utcNow)}
                                    presence="future"
                                />
                                <h3 className="title title--h3">{t("Entities.Schedule.HolidaysPast")}</h3>
                                <HolidaysList
                                    holidays={partner.holidaySchedule.holidays.filter((u) => u.dtStop <= utcNow)}
                                    presence="past"
                                />
                            </div>
                        ) : (
                            <p className="caption caption--italic">{t("Entities.Schedule.HolidaysNone")}</p>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};
